import { render } from "./ExpandLess.vue?vue&type=template&id=1c082aeb&scoped=true"
const script = {}

import "./ExpandLess.vue?vue&type=style&index=0&id=1c082aeb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c082aeb"]])

export default __exports__